const o = {
  Passport: "PASSPORT",
  Cid: "CID"
};
export {
  o as r
};
//# sourceMappingURL=PersonalIdRequest-635e09d2.mjs.map
